/**
 * User command handlers
 */

import chalk from 'chalk';
import { createUserService } from '../utils/client.js';
import { cliError, handleApiError } from '../utils/errors.js';
import { formatOutput } from '../utils/format.js';

export async function updateUser(
  name?: string,
  photo?: string,
  token?: string,
  apiUrl?: string,
  json?: boolean
): Promise<void> {
  if (name === undefined && photo === undefined) {
    cliError('Provide at least one profile field: --name <displayName> or --photo <url>', 1);
  }

  try {
    const service = await createUserService(token, apiUrl);
    const params: { displayName?: string; photoURL?: string } = {};
    if (name !== undefined) params.displayName = name;
    if (photo !== undefined) params.photoURL = photo;

    const result = await service.updateProfile(params);

    if (json) {
      console.log(formatOutput(result.user, true));
    } else {
      console.log('');
      console.log(`  ${chalk.green.bold('✓ User profile updated')}`);
      console.log(chalk.dim('  ' + '─'.repeat(40)));
      if (name !== undefined) {
        console.log(`  ${chalk.dim('Name')}   ${chalk.bold.white(result.user.displayName ?? name)}`);
      }
      if (photo !== undefined) {
        console.log(`  ${chalk.dim('Photo')}  ${chalk.dim(result.user.photoURL ?? photo)}`);
      }
      console.log('');
    }
  } catch (error) {
    handleApiError(error);
  }
}
